import { intersect, literal, partial, struct } from 'io-ts/Decoder';

import { Id as FloorLevel } from '../../../ai/floor-level/Id';

/**
 * Sent when the floor level for a page is assigned/updated by the estimator.
 */
export const FloorLevelAssigned = intersect(
	struct({
		type: literal('floor-level-assigned'),
		floorLevel: FloorLevel,
	})
)(
	partial({
		/**
		 * The canonical floor level of the page *before* this change was
		 * accepted. Stamped server-side at draft-confirm time (while the
		 * pre-fold state is still available) so the Brain Engine
		 * `floorLevelUpdated.oldFloorLevel` reflects the true previous level
		 * rather than the already-updated state.
		 */
		previousFloorLevel: FloorLevel,
	})
);
